import D from 'date-fns'
import Image from 'next/legacy/image'
import s from './styles.module.css'

export default function AuthorCardSection({ post }) {
  return (
    <div className={s.author}>
      {!!post.fields.author?.fields.profileImage?.fields && (
        <div className={s.authorImage}>
          <Image
            alt={post.fields.author.fields.profileImage.fields.title}
            src={`https:${post.fields.author.fields.profileImage.fields.file.url}`}
            layout="fill"
            objectFit="cover"
            objectPosition="top"
          />
        </div>
      )}
      <div className={s.nameDate}>
        <span className={s.name}>{post.fields.author?.fields.name}</span>
        <time className={s.date} dateTime={post.sys.updatedAt}>
          {D.format(post.sys.updatedAt, 'MMM D, YYYY')}
        </time>
      </div>
    </div>
  )
}
